<div class="edit-header" [ngClass]="{'edit-mode' : editing}">
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-6">
        <button (click)="backToList()" class="btn btn-secondary back"><i class="fa fa-angle-double-left"></i> Back to list</button>
        <div class="title" *ngIf="!editing">{{ storyboard.title }} <i class="fa fa-pencil" (click)="swapEditMode()" *ngIf="!storyboard.read_only"></i></div>
        <div class="title" [hidden]="!editing"><input type="text" #input [(ngModel)]="tmpTitle" class="form-control"  placeholder="Storyboard Title"/> <i class="fa fa-times-circle fa-2x" (click)="swapEditMode()"></i> <i class="fa fa-check-circle fa-2x" (click)="saveTitle()"></i> <i class="fa fa-spin fa-spinner" *ngIf="titleSaving"></i></div>
      </div>
      <div class="col-md-6">
        <div class="edit-menu text-right" *ngIf="!storyboard.read_only">
          <label class="auto-save">
            Auto Save
            <input type="checkbox" (change)="toggleAutoSave($event)" [ngModel]="autoSave" name="autosave"/>
          </label>
          <button class="btn btn-primary" [disabled]="storyboardSaving" (click)="save()"><i class="fa fa-floppy-o"></i> Save <i class="fa fa-spin fa-spinner" *ngIf="storyboardSaving"></i></button>
          <button class="btn btn-primary" *ngIf="isAllowedToPublishVideo()" [disabled]="publishing" (click)="publish()"><i class="fa fa-send-o"></i> Publish Video <i class="fa fa-spin fa-spinner" *ngIf="publishing"></i></button>
        </div>
      </div>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/storyboard/storyboard-edit/storyboard-edit-header/storyboard-edit-header.component.html